// src/components/common/SimpleModal.js (or choose your path)
import React from 'react';
import { FaTimes } from 'react-icons/fa';

const modalStyles = {
    overlay: {
        position: 'fixed',
        top: 0,
        left: 0,
        right: 0,
        bottom: 0,
        backgroundColor: 'rgba(0, 0, 0, 0.1)',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        zIndex: 1000, // Ensure it's on top
    },
    content: {
        backgroundColor: '#ffffff',
        padding: '0', // Remove padding, let form handle it
        borderRadius: '8px',
        boxShadow: '0 5px 15px rgba(0, 0, 0, 0.2)',
        position: 'relative',
        width: '90%', // Responsive width
        maxWidth: '950px', // Max width like the original form
        maxHeight: '90vh', // Prevent modal from being too tall
        overflowY: 'auto', // Allow scrolling if content exceeds height
        zIndex: 1001,
    },
    header: {
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'center',
        padding: '15px 25px',
        borderBottom: '1px solid #e9ecef',
        backgroundColor: '#f8f9fa',
        borderTopLeftRadius: '8px',
        borderTopRightRadius: '8px',
    },
    title: {
        margin: 0,
        fontSize: '1.4em',
        fontWeight: '600',
        color: '#343a40',
    },
    closeButton: {
        background: 'none',
        border: 'none',
        fontSize: '1.5em',
        cursor: 'pointer',
        color: '#6c757d',
        padding: '5px',
        lineHeight: 1,
    },
    body: {
         padding: '20px 25px 30px 25px', // Add padding around the form content
    }
};

function SimpleModal({ isOpen, onClose, title, children }) {
    if (!isOpen) return null;

    // Prevent closing modal when clicking inside the content
    const handleContentClick = (e) => {
        e.stopPropagation();
    };

    return (
        <div style={modalStyles.overlay} onClick={onClose}>
            <div style={modalStyles.content} onClick={handleContentClick}>
                <div style={modalStyles.header}>
                     <h2 style={modalStyles.title}>{title}</h2>
                    <button onClick={onClose} style={modalStyles.closeButton} title="Close">
                        <FaTimes />
                    </button>
                </div>
                <div style={modalStyles.body}>
                    {children}
                </div>
            </div>
        </div>
    );
}

export default SimpleModal;